class AccordionGroup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.els.trigger.elements.forEach(triggerEl => {
      this.listeners.add(triggerEl, `click`, this.handleTrigger)
    })
  }

  handleTrigger (event) {
    const itemEl = event.target.closest(this.els?.item?.selector)
    const parentEl = itemEl.parentElement

    if (this.dataset.type === 'oneopen') {
      parentEl.querySelectorAll(this.els?.item?.selector).forEach(tempEl => {
        if (tempEl !== itemEl) {
          tempEl.setAttribute('aria-expanded', 'false')
        }
      })
    }

    const contentEl = itemEl.querySelector(this.els?.content?.selector)
    const currentState = itemEl.getAttribute('aria-expanded') === 'true'
    const scrollToDiv = event.target.closest('.prd-Accordion')

    itemEl.style.setProperty('--Max_Height', `${contentEl.offsetHeight}px`)
    itemEl.setAttribute('aria-expanded', !currentState)

    if (!scrollToDiv) {
      return
    }

    const rect = scrollToDiv.getBoundingClientRect()
    const scrollTop = window.scrollY || document.documentElement.scrollTop
    const topPosition = rect.top + scrollTop
    const offset = 180

    setTimeout(() => {
      window.scrollTo({ top: topPosition - offset, behavior: 'smooth' })
    }, 200)
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup)
}
